export const GET_DEPOSIT = 'GET_DEPOSIT';
export const GET_DEPOSIT_SUCCESS = 'GET_DEPOSIT_SUCCESS';
export const GET_DEPOSIT_FAIL = 'GET_DEPOSIT_FAIL';

export const RESET_DEPOSIT_ALERTS_ERRORS = 'RESET_DEPOSIT_ALERTS_ERRORS';
